import React from 'react'

function Intro() {
  return (
    <>
      <div className='w-full bg-gray-100 py-8 px-4'>
        <div className='max-w-[1240px] mx-auto text-center'>
          <h1 className='font-bold md:text-4xl sm:text-3xl text-2xl py-3'>Вспомним всё...</h1>
          <p className='text-left mx-auto py-1'> Дорогие друзья! Все, кто помнит и любит сайт kayrakkum.com, или пока ещё не забыл.
            Так получилось, что реальность оказывается порой сильнее наших самых сильных привязанностей. За прошедшие 20 лет интернет вырос из доступного едицам развлечения
            до привычного, обыденного и порой даже незаменимого для многих атрибута жизни. Современной жизни.</p>
          <p className='text-left mx-auto py-1'>Когда много лет назад мы основали сайт kayrakkum.com, это была как раз первая фаза, и мы хотели сделать что-то
            приятное и нужное всем нам и вам. Что из этого получилось - судить вам. Мы просто хотели, чтобы наше виртуальное общение
            было живым и здоровым, тёплым и домашним. Мы честно старались.</p>
          <p className='text-left mx-auto py-1'>Шли годы, появлялись новые пожелания, требования, и возможности. Необходимо было идти в ногу со временем,
            и мы старались не отставать. Мы несколько раз обновляли сайт, всего за все эти годы было четыре поколения сайта.
            Нужно заметить, что всё это делалось и поддерживалось нами на чистом энтузиазме, только из одного желания - сайт должен
            жить и приносить радость. </p>
          <p className='text-left mx-auto py-2'>Сегодня старому доброму сайту Кайраккум уже больше 22 лет. Уже давно город Кайраккум сменил своё название, а сайт было решено оставить, как памятник ушедшей эпохе, нашей юности.
Как говорится, добро пожаловать!</p>
        </div>
      </div>
    </>
  )
}

export default Intro